import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Dashboard from "../components/dashboard";
import Balances from "../components/balances";
import KredafiHome from "../kredafi/KredafiHome";
import VoucherBanner from "../components/VoucherBanner";
import { useSelector } from "react-redux";
import {
  SettingTwoTone,
  BellTwoTone,
} from "@ant-design/icons";
import { Badge } from "antd";
import { RootState } from "../services/store";
import { getVoucherStatus, VoucherStatus } from "../helpers/api";
import { isKredafiShell } from "../utils/brand";

const Home: FC = () => {
  const navigate = useNavigate();
  const { userData, isLoading } = useSelector((state: RootState) => state.user);
  const [showVoucherModal, setShowVoucherModal] = useState(false);
  // Статус ваучера тянем один раз здесь и отдаём и баннеру, и карточке внутри
  // Balances — чтобы не делать два одинаковых запроса.
  const [voucher, setVoucher] = useState<VoucherStatus | null>(null);

  // Ждём userData: auth_token кладётся в localStorage внутри .then() у addUser()
  // (App.tsx) прямо перед setUserData. Запрос раньше этого момента уходит без
  // Authorization → 401, а интерцептор ответов на 401 ещё и стирает токен.
  useEffect(() => {
    if (!userData?.id) return;
    let cancelled = false;
    getVoucherStatus().then((v) => {
      if (!cancelled) setVoucher(v);
    });
    return () => {
      cancelled = true;
    };
  }, [userData?.id]);

  return (
    userData && (
      isKredafiShell() ? (
        <KredafiHome
          voucher={voucher}
          externalVoucherTrigger={showVoucherModal}
          onVoucherDrawerClose={() => setShowVoucherModal(false)}
        />
      ) : (
      <>
        <div className="header">
            <Badge count={!isLoading && userData.unread_notifications}>
              <BellTwoTone
                onClick={() => navigate("/notifications")}
                style={{
                  fontSize: "24px",
                  cursor: "pointer",
                }}
              />
            </Badge>
            <SettingTwoTone
              onClick={() => navigate("/settings")}
              style={{ fontSize: "24px", cursor: "pointer", marginLeft: 10 }}
            />
        </div>

        {/* VOUCHER BANNER ON HOME PAGE */}
        <VoucherBanner
          voucher={voucher}
          onOpenVoucher={() => setShowVoucherModal(true)}
        />

        <Balances
          voucher={voucher}
          externalVoucherTrigger={showVoucherModal}
          onVoucherDrawerClose={() => setShowVoucherModal(false)}
        />
        <Dashboard />
      </>
      )
    )
  );
};

export default Home;
